import { FinResourceType } from "../definitions/types"
import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-prompt-input-field",
	imports: [
		COMMON_IMPORTS,
		GenInputComponent,
		CancelBtnComponent,
		BtnExtComponent,
		LangValPipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<h4 class="prompt-text">
			{{ bodyTitle | langVal }}
		</h4>
		<div class="prompt-input">
			<app-gen-input
				fieldName="num"
				[actualObj]="this"
				title_ph_lang="number"
			>
			</app-gen-input>
		</div>

		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<app-btn-ext
				tabindex="5"
				text="add"
				[disabled]="!num"
				(clickEv)="onClose.emit(num)"
			/>
		</div>
	`,
})
export class PromptInputFieldComponent extends Modalable {
	@Input() num: number = 0 //the number of the first document to start counting from
	@Input() bodyTitle: string = ""
}
